import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LeagueMediaService } from '@core/services/league-media.service';
import { componentDestroyed, Game, League, Tournament, UntilDestroy } from '@mtgame/core';
import { takeUntil } from 'rxjs/operators';
import { getLeagueMediaDetailRoute } from '@config/routes';
import { SeoService } from '@core/services/seo.service';
import { combineLatest } from 'rxjs';
import { getHeaderHeight } from '@utils/layout';
import { LeagueRootService } from '@core/services/league-root.service';

@UntilDestroy
@Component({
  selector: 'mtg-league-media',
  templateUrl: './league-media.component.html',
  styleUrls: ['./league-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueMediaComponent implements OnInit, OnDestroy {
  games: Game[] = [];
  tournaments: Tournament[] = [];
  loading = false;
  headerHeight = getHeaderHeight();
  league = this.leagueRootService.getLeagueModel();

  constructor(
    private leagueRootService: LeagueRootService,
    private seoService: SeoService,
    private leagueMediaService: LeagueMediaService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.seoService.setData({title: 'Медиа'});
    combineLatest([
      this.leagueMediaService.tournaments$.pipe(takeUntil(componentDestroyed(this))),
      this.leagueMediaService.games$.pipe(takeUntil(componentDestroyed(this)))
    ]).subscribe(([tournaments, games]) => {
      this.tournaments = tournaments;
      this.games = games;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    this.leagueMediaService.dispose();
  }

  async loadNextPage(): Promise<void> {
    if (this.loading) {
      return Promise.resolve();
    }
    this.loading = true;
    const media = await this.leagueMediaService.loadNextPage();
    if (media.length === 0) {
      this.loading = false;
    }
    setTimeout(() => {
      this.loading = false;
      this.cdr.markForCheck();
    }, 500);
  }

  async setFilter(filter: any): Promise<void> {
    await this.leagueMediaService.setFilter(filter.tournament ? filter.tournament.id : null, filter);
  }

  get leagueMediaRouteDetail(): string {
    return getLeagueMediaDetailRoute().join('/');
  }
}
